import entries from 'lodash/entries';

const VALUE_TO_EXCLUDE = 'orgJobCurrency';

export const filterSelectedJobs = (jobsOnPage, selectedJobs) => {
  const selectedJobsIds = selectedJobs.map(job => job.id);
  return jobsOnPage.filter(job => {
    return selectedJobsIds.includes(job.id);
  });
};

export const getJobIds = jobs => {
  return jobs.map(job => job.orgJobId);
};

export const showResetBtn = (searchCriteria = {}) => {
  // MPE-5608: Lodash cleanup, some
  return searchCriteria.some(filterSearchCriteria);
};

export const filterSearchCriteria = bucket => {
  const facets = entries(bucket);

  return !!facets.find(([facetLabel, facetItems]) => {
    return VALUE_TO_EXCLUDE !== facetLabel && !!facetItems.length;
  });
};
